import { render, staticRenderFns } from "./chooseProject.vue?vue&type=template&id=2164ee32&"
import script from "./chooseProject.vue?vue&type=script&lang=js&"
export * from "./chooseProject.vue?vue&type=script&lang=js&"
import style0 from "./chooseProject.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports